"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgTrunk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "100%"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M.03.045h.082V.2H.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    d: "M.033.016h.079v.405H.033z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    d: "M.01.054h36.344v44.812H.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-7",
    d: "M.004.013H6.08v6.249H.004z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-9",
    d: "M.004.066H6.08v3.507H.004z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-11",
    d: "M.004.013H6.08v6.249H.004z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-13",
    d: "M.004.005H6.08v6.25H.004z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-15",
    d: "M.004.006H6.08v3.578H.004z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-17",
    d: "M.042.072h.182v3.505H.042z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-19",
    d: "M.004.005H6.08v6.25H.004z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-21",
    d: "M.042 0h.182v3.581H.042z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-23",
    d: "M.026.024h16.083v7.144H.026z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-25",
    d: "M.026.056h16.083v7.085H.026z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-27",
    d: "M.004.02H3.51v1.757H.004z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-29",
    d: "M.003.012H3.38v1.76H.003z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Auto/compacto/Cajuela",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "rotate(90 11 53)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.45-.307C2.035-.307.071-.08.03.2h8.838c-.041-.28-2.006-.507-4.419-.507",
    id: "Fill-1",
    fill: "#CDCDCA",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "rotate(90 -11 31)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.452.421C2.039.421.074.24.033.016H8.87C8.83.24 6.865.421 4.452.421",
    id: "Fill-4",
    fill: "#CDCDCA",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "rotate(90 29.5 35.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.151 44.001s.45-.268 6.557-2.4c2.183-1.078 3.985-5.025 6.31-12.436.475-.673.456-12.845 0-13.49-2.325-7.412-4.127-11.36-6.31-12.438-6.106-2.131-6.557-2.4-6.557-2.4C103.256-.417 93.165-.01 90.523.24H26.087c-2.378 0-4.75.136-7.11.404-5.329.612-9.546 1.223-14.08 2.883-6.523 3.856-6.507 33.94 0 37.785 4.534 1.66 8.751 2.271 14.08 2.882 2.36.268 4.732.405 7.11.405h64.436c2.642.247 12.733.657 16.628-.598",
    id: "Fill-7",
    fill: "#DFDFDC",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52 19c.755-5.702 2.386-9.008 5.469-10.872 1.343-.155 2.623-.174 4.169-.03.463.042.485.213.048.376-3.655 1.365-4.894 2.453-5.77 4.024C54.633 13.722 53.334 15.437 52 19",
    id: "Fill-10",
    fill: "#891214",
    transform: "rotate(90 57 13.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 16c.324-1.332.743-2.455 1.279-3.4.712-.902 1.45-1.587 2.282-2.105h-.584c.167-.146.34-.285.519-.415l2.229-.079c.354-.011.368.065.032.183C58.366 11.02 56.793 12.712 55 16",
    id: "Fill-12",
    fill: "#E2272C",
    transform: "rotate(90 58 13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 8c.755 5.702 2.386 9.008 5.469 10.872 1.343.155 2.623.174 4.169.03.463-.042.485-.213.048-.376-3.655-1.365-4.894-2.453-5.77-4.024C25.633 13.278 24.334 11.563 23 8",
    id: "Fill-14",
    fill: "#891214",
    transform: "rotate(90 28 13.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 10c.324 1.332.743 2.455 1.279 3.4.712.902 1.45 1.587 2.282 2.105h-.584c.167.146.34.285.519.415l2.229.079c.354.011.368-.065.032-.183C27.366 14.98 25.793 13.288 24 10",
    id: "Fill-16",
    fill: "#E2272C",
    transform: "rotate(90 27 13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.92 45c-5.126-6.889-5.326-23.976 0-31L51 16.918c-2.092 5.83-2.097 19.21 0 25.164L37.92 45z",
    id: "Fill-18",
    fill: "#2B3D44",
    transform: "rotate(90 42.5 29.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.463 29.38c0-2.967.328-5.879.948-8.42.526-2.158 1.264-4.04 2.16-5.52.284-.47.822-.706 1.346-.59l10.673 2.382a.66.66 0 01.478.822c-.77 2.82-1.218 6.958-1.218 11.408 0 4.458.45 8.626 1.223 11.485a.659.659 0 01-.478.82l-10.666 2.38a1.256 1.256 0 01-1.353-.6c-.883-1.491-1.617-3.395-2.147-5.583-.632-2.613-.966-5.581-.966-8.585zM51 42.081c-1.048-2.975-1.57-7.805-1.57-12.62 0-4.82.523-9.627 1.57-12.544L37.92 14C35.281 17.478 34 23.424 34 29.378c0 6.068 1.332 12.145 3.92 15.622L51 42.082z",
    id: "Fill-20",
    fill: "#1D2A30",
    transform: "rotate(90 42.5 29.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "rotate(90 -4 32)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.267 6.068c-1.135-.974-5.944-2.48-7.959-3.083C30.5-.246 20.996-.209 12.122.215 7.02.66 3.884 1.4.944 2.85c-.46.227-.94.627-.94 1.182 0 .306.144.544.338.754l49.15 1.476-.225-.194z",
    id: "Fill-22",
    fill: "#2B3D44",
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "rotate(90 -5 30.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.267 3.372c-.604-.54-2.25-1.236-3.96-1.864L.865.066C.43.308.004.709.004 1.254c0 .318.144.566.338.784l49.15 1.535-.225-.201z",
    id: "Fill-25",
    fill: "#445D66",
    mask: "url(#mask-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "rotate(90 -4 32)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.59 5.735L.75 4.328a.57.57 0 01-.067-.427c.061-.252.293-.489.654-.667C4.18 1.832 7.224 1.117 12.192.681c7.992-.38 17.774-.575 28.84 2.735.6.18 1.172.356 1.715.528 2.38.846 4.027 1.455 4.844 1.791zm1.677.333c-1.135-.974-5.944-2.48-7.959-3.083C30.5-.246 20.996-.209 12.122.215 7.02.66 3.884 1.4.943 2.85c-.46.227-.94.627-.94 1.182 0 .306.145.544.339.754l49.15 1.476-.225-.194z",
    id: "Fill-28",
    fill: "#131313",
    mask: "url(#mask-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "rotate(90 13.5 49.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.267.199c-1.135.974-5.944 2.48-7.959 3.083C30.5 6.513 20.996 6.476 12.122 6.053 7.02 5.606 3.884 4.867.944 3.417c-.46-.226-.94-.627-.94-1.182 0-.306.144-.544.338-.754L49.492.005 49.267.2z",
    id: "Fill-31",
    fill: "#2B3D44",
    mask: "url(#mask-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "rotate(90 14 49.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.267.211l.225-.205L.342 1.572c-.194.223-.338.475-.338.8 0 .556.427.965.862 1.212l44.44-1.472c1.711-.64 3.357-1.35 3.961-1.901",
    id: "Fill-34",
    fill: "#445D66",
    mask: "url(#mask-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "rotate(90 10 51.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.042 3.435L.383.092l.541-.02-.359 3.505a17.361 17.361 0 01-.523-.142",
    id: "Fill-37",
    fill: "#131313",
    mask: "url(#mask-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-42",
    transform: "rotate(90 13.5 49.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.747 2.323c-.543.172-1.114.349-1.715.528-11.066 3.31-20.848 3.115-28.84 2.735C7.224 5.151 4.18 4.435 1.337 3.033c-.36-.178-.593-.415-.654-.667a.57.57 0 01.067-.427L47.59.532c-.816.336-2.462.945-4.843 1.791zM49.492.005L.342 1.481c-.194.21-.338.448-.338.754 0 .555.48.956.94 1.182 2.94 1.45 6.075 2.19 11.178 2.636 8.874.423 18.378.46 29.186-2.771 2.015-.603 6.824-2.109 7.959-3.083l.225-.194z",
    id: "Fill-40",
    fill: "#131313",
    mask: "url(#mask-20)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "rotate(90 -7 34.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.042.147L.383 3.56l.541.02L.565.001C.388.047.214.096.042.147",
    id: "Fill-43",
    fill: "#131313",
    mask: "url(#mask-22)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47 30a36.993 36.993 0 01-2.402-.807c-6.123-3.704-6.138-32.676 0-36.389A36.643 36.643 0 0146.99-8c-.372.62-3.54 1.193-5.042 7.44l.002-.002c-.762 3.172-.955 7.08-1.015 10.34v2.478c.06 3.29.257 7.174 1.015 10.334l-.002-.004C43.436 28.77 46.594 29.454 47 30",
    id: "Fill-46",
    fill: "#CDCDCA",
    transform: "rotate(90 43.5 11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 25a11.752 11.752 0 01-1.584-1.518c-1.03-1.18-1.944-2.646-2.785-4.425-.366-2.197-.562-4.766-.63-7.765L40 9.968l.001-1.26c.068-3 .264-5.567.63-7.763.84-1.78 1.754-3.245 2.784-4.426.5-.572 1.026-1.077 1.585-1.519-3.782 3.268-3.954 10.611-3.954 15 0 4.389.172 11.733 3.954 15",
    id: "Fill-48",
    fill: "#F2F2F2",
    transform: "rotate(90 42.5 10)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-52",
    transform: "rotate(90 16 41.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.673 6.11c3.634-.56 5.065-.817 8.641-1.631 1.326-.296 2.9-.676 4.506-1.151 10.682-3.161 9.515-4.357-.755-2.243-1.688.347-3.24.688-4.37.892-2.961.548-4.251.783-8.454 1.339-5.124.575-7.735.742-12.973.912-2.736.082-6.367.163-9.1.076-4.546-.165-6.163-.367-9.463-.802-1.558-.247-2.891-.512-4.07-.701-6.655-1.066-8.011-.119-.658 1.96 1.35.382 2.746.698 4.26 1.032 3.442.647 5.167.933 9.798 1.241 2.885.173 6.434.151 9.317.088 5.287-.14 8.009-.323 13.321-1.012",
    id: "Fill-50",
    fill: "#F2F2F2",
    mask: "url(#mask-24)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-55",
    transform: "rotate(90 4.5 30)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.673 1.106c3.634.555 5.065.81 8.641 1.617 1.326.294 2.9.67 4.506 1.142 10.682 3.134 9.515 4.32-.755 2.223-1.688-.344-3.24-.682-4.37-.884-2.961-.544-4.251-.777-8.454-1.328-5.124-.57-7.735-.736-12.973-.904-2.736-.081-6.367-.162-9.1-.075-4.546.163-6.163.363-9.463.795-1.558.244-2.891.507-4.07.695-6.655 1.057-8.011.118-.658-1.944 1.35-.379 2.746-.692 4.26-1.023C12.68.78 14.404.495 19.035.19 21.92.017 25.469.04 28.352.102c5.287.139 8.009.32 13.321 1.003",
    id: "Fill-53",
    fill: "#F2F2F2",
    mask: "url(#mask-26)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.678 29.577c-6.737-1.394-8.11-.155-.667 2.563 1.367.499 2.78.911 4.313 1.347.798.194 1.504.363 2.175.513.142-.877.301-1.691.476-2.43a.91.91 0 00-.14-.738c-.629-.1-1.29-.212-2.037-.34-1.577-.321-2.927-.668-4.12-.915",
    id: "Fill-56",
    fill: "#445D66",
    transform: "rotate(90 54 31.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.386 34.896a60.825 60.825 0 00-.386 2.95c.16.053.316.105.471.154.15-1.406.326-2.697.529-3.835-.24-.052-.48-.107-.727-.165.116.236.165.57.113.896",
    id: "Fill-58",
    fill: "#31444C",
    transform: "rotate(90 52.5 36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.975 31.433A35.576 35.576 0 0136.502 29c-.673.15-1.382.32-2.182.514-1.532.436-2.945.849-4.31 1.347-7.44 2.718-6.068 3.955.665 2.562 1.193-.247 2.542-.593 4.118-.915.75-.128 1.412-.24 2.043-.34a.908.908 0 00.14-.735",
    id: "Fill-60",
    fill: "#445D66",
    transform: "rotate(90 31 31.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 34.154c.115 1.063.244 2.053.386 2.954.052.326.002.657-.114.892.247-.058.489-.113.728-.164A57.1 57.1 0 0131.473 34c-.156.05-.313.1-.473.154",
    id: "Fill-62",
    fill: "#31444C",
    transform: "rotate(90 31.5 36)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-66",
    transform: "rotate(90 -3.5 34.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.004.553C5.81-.09 10.778-.02 16.187.098c7.33.162 13.131.634 19.33 1.63l-.035.049C29.288.78 23.512.313 16.185.15 10.78.031 5.827-.039.026.605L.004.553z",
    id: "Fill-64",
    fill: "#9A9A9A",
    mask: "url(#mask-28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-69",
    transform: "rotate(90 9.5 47.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-29"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.003 1.238l.022-.052c5.588.644 10.358.574 15.567.455 7.057-.162 12.62-.633 18.589-1.629l.035.05c-5.97.997-11.561 1.47-18.623 1.632-5.21.12-9.998.19-15.59-.456",
    id: "Fill-67",
    fill: "#9A9A9A",
    mask: "url(#mask-30)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20 17.84a6.36 6.36 0 011.067-.048l.316.016c3.612.19 8.501.43 11.574.35l.043.04c-3.076.08-8.009-.153-11.622-.343l-.316-.017a5.986 5.986 0 00-1.025.052L20 17.84z",
    id: "Fill-70",
    fill: "#9A9A9A",
    transform: "rotate(90 26.5 18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 18.176l.032-.039c.345.04.674.04 1.03.022l.325-.017c3.611-.186 8.54-.42 11.613-.341l-.045.041c-3.07-.079-7.954.16-11.563.346l-.325.017c-.36.019-.718.01-1.067-.029",
    id: "Fill-72",
    fill: "#9A9A9A",
    transform: "rotate(90 57.5 18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 34l.038.002c.631 1.51 1.124 2.433 1.77 3.636L23 38h-.066l-.164-.305A38.127 38.127 0 0121 34",
    id: "Fill-74",
    fill: "#9A9A9A",
    transform: "rotate(90 22 36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 38a38.153 38.153 0 011.774-3.694L63.94 34H64l-.187.363a37.004 37.004 0 00-1.737 3.634L62 38z",
    id: "Fill-76",
    fill: "#9A9A9A",
    transform: "rotate(90 63 36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.903 13.972l.062-.077c.155-.188.248-.522.25-.895l-.05.029c-.003.325-.083.595-.225.768-.052.063-.105.138-.155.203l.118-.028z",
    id: "Fill-78",
    fill: "#9A9A9A",
    transform: "rotate(90 62 13.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.976 12.842a4.391 4.391 0 01-.079-.045l-.112-.012c.054.033.11.07.166.1.138.078.215.171.217.317l.047.013c-.002-.167-.09-.289-.24-.373",
    id: "Fill-80",
    fill: "#9A9A9A",
    transform: "rotate(90 22 13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.552 21.079c-.308 0-.603.037-.854.117-.376.12-.597.311-.623.541-.026.23.145.475.483.692.716.46 1.947.628 2.744.375.376-.12.597-.311.623-.541.026-.23-.145-.475-.483-.692-.49-.314-1.222-.492-1.89-.492M22.45 23c-.682 0-1.429-.182-1.929-.503-.364-.233-.548-.507-.518-.77.03-.263.27-.479.674-.607.814-.258 2.07-.086 2.802.383.364.233.548.507.518.77-.03.263-.27.479-.674.607a2.93 2.93 0 01-.873.12",
    id: "Fill-82",
    fill: "#9A9A9A",
    transform: "rotate(90 22 22)"
  })));
}
var _default = exports["default"] = SvgTrunk;